var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg11Labs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_620_3612)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_620_3612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 2.09998H11C6.63693 2.09998 3.09998 5.63693 3.09998 9.99998V26C3.09998 30.363 6.63693 33.9 11 33.9H27C31.363 33.9 34.9 30.363 34.9 26V9.99998C34.9 5.63693 31.363 2.09998 27 2.09998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 13H20V23.3582H22V13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13H16V23.3582H18V13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 2.09998H11C6.63693 2.09998 3.09998 5.63693 3.09998 9.99998V26C3.09998 30.363 6.63693 33.9 11 33.9H27C31.363 33.9 34.9 30.363 34.9 26V9.99998C34.9 5.63693 31.363 2.09998 27 2.09998Z",
    stroke: "#D0D5DD",
    strokeWidth: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_620_3612",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_620_3612"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_620_3612",
    result: "effect2_dropShadow_620_3612"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_620_3612",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_620_3612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11Labs);
export default __webpack_public_path__ + "static/media/11labs.3770517fc624f184983ad04abb6d974e.svg";
export { ForwardRef as ReactComponent };